export default "/fonts/vendor/katex/dist/KaTeX_Typewriter-Regular.woff2?c295e7f71970f03c0549228b1c18120a";